export function isStickySectionShorterThanWindowHeight(
  stickySectionHeight,
  desktopNavHeight
) {
  return stickySectionHeight + desktopNavHeight <= window.innerHeight
}
